import {combineReducers} from 'redux'
import UploadFile from 'uploads/redux/reducer'

const rootReducer = combineReducers({UploadFile})

export default rootReducer
